/** JSON-буфер сеанса графика кабинета (шапка + услуги). */

export const SPR_ZAL_GRAF_CLIPBOARD_TYPE = "planOnline.sprZalGrafSession";

export const buildGrafSessionClipboard = ({
  cntMax = 1,
  idSotr = 0,
  idSotrRun = 0,
  timeBeg,
  timeEnd,
  usl = []
}) => ({
  type: SPR_ZAL_GRAF_CLIPBOARD_TYPE,
  version: 1,
  cntMax: Number(cntMax) || 1,
  idSotr: Number(idSotr) || 0,
  idSotrRun: Number(idSotrRun) || 0,
  timeBeg: timeBeg || "09:00",
  timeEnd: timeEnd || "09:30",
  usl: Array.isArray(usl)
    ? usl.map((id) => Number(id)).filter((id) => Number.isFinite(id) && id > 0)
    : []
});

export const parseGrafSessionClipboard = (text) => {
  if (!text || typeof text !== "string") return null;
  let data;
  try {
    data = JSON.parse(text);
  } catch {
    return null;
  }
  if (!data || data.type !== SPR_ZAL_GRAF_CLIPBOARD_TYPE) return null;
  return buildGrafSessionClipboard(data);
};

export const writeGrafSessionClipboard = async (payload) => {
  const json = JSON.stringify(buildGrafSessionClipboard(payload));
  if (!navigator?.clipboard?.writeText) {
    throw new Error("Буфер обмена недоступен");
  }
  await navigator.clipboard.writeText(json);
  return json;
};

export const readGrafSessionClipboard = async () => {
  if (!navigator?.clipboard?.readText) {
    throw new Error("Буфер обмена недоступен");
  }
  const text = await navigator.clipboard.readText();
  const data = parseGrafSessionClipboard(text);
  if (!data) throw new Error("В буфере нет данных сеанса");
  return data;
};

/** JSON-буфер дня графика кабинета (все сеансы + услуги). */
export const SPR_ZAL_GRAF_DAY_CLIPBOARD_TYPE = "planOnline.sprZalGrafDay";

export const buildGrafDayClipboard = ({ sessions = [] } = {}) => ({
  type: SPR_ZAL_GRAF_DAY_CLIPBOARD_TYPE,
  version: 1,
  sessions: (Array.isArray(sessions) ? sessions : [])
    .map((s) => buildGrafSessionClipboard(s))
    .map(({ type, version, ...rest }) => rest)
});

export const parseGrafDayClipboard = (text) => {
  if (!text || typeof text !== "string") return null;
  let data;
  try {
    data = JSON.parse(text);
  } catch {
    return null;
  }
  if (!data || data.type !== SPR_ZAL_GRAF_DAY_CLIPBOARD_TYPE) return null;
  return buildGrafDayClipboard(data);
};

export const writeGrafDayClipboard = async (payload) => {
  const json = JSON.stringify(buildGrafDayClipboard(payload));
  if (!navigator?.clipboard?.writeText) {
    throw new Error("Буфер обмена недоступен");
  }
  await navigator.clipboard.writeText(json);
  return json;
};

export const readGrafDayClipboard = async () => {
  if (!navigator?.clipboard?.readText) {
    throw new Error("Буфер обмена недоступен");
  }
  const text = await navigator.clipboard.readText();
  const data = parseGrafDayClipboard(text);
  if (!data) throw new Error("В буфере нет данных дня графика");
  return data;
};
